import { URL_BY_BRAND } from "@/constant/constantsThrougoutProject";

export const getFeatureRedirect = (
  status: Record<string, Record<string, boolean>>
): string => {
  for (const key in status) {
    if (
      Object.prototype.hasOwnProperty.call(status, key) &&
      typeof status[key] === "object" &&
      status[key] !== null
    ) {
      const subObject = status[key];
      const subKeys = Object.keys(subObject);
      const allTrue = subKeys.every((subKey) => subObject[subKey] === true);

      if (allTrue && subKeys.length > 0) {
        return `/${key}/${URL_BY_BRAND}`;
      }
    }
  }

  return "";
};
